import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes";

const baseRoute = `/cost-management/store-cost`;

export const storeCostManagementRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create`,
  edit: `${baseRoute}/edit/:costId`,
} as const;

export type IStoreCostManagementRouteParams = IExtractRouteParamMap<
  typeof storeCostManagementRoutesObj
>;

export const storeCostManagementPath = createPaths<
  typeof storeCostManagementRoutesObj,
  IStoreCostManagementRouteParams
>(storeCostManagementRoutesObj);
